export const resultPerPageDropdownItemsConfig = [
  15,
  30,
  45,
  60,
];
